import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxProps, Text } from '/src/components';
import { IncentiveStatementResponse, normalizeIncentiveStatementResponse } from '/src/lib/models';
import { pxToPt } from '/src/utils';

export const IncentiveStatementInfoBar: React.FC<IncentiveStatementInfoBarProps> = (props) => {
  const { incentiveStatement, ...boxProps } = props;
  const { t } = useTranslation();

  const normalized = normalizeIncentiveStatementResponse(incentiveStatement);

  const lineHeight = useRef(pxToPt('24px'));
  const labelSize = useRef(pxToPt('14px'));
  const valueSize = useRef(pxToPt('12px'));

  return (
    <Box direction="row" justify="between" {...boxProps}>
      <Box direction="row" width="50%">
        <Box width="50%">
          <Text size={labelSize.current} lineHeight={lineHeight.current} weight={700}>
            {t('common:clientName')}
          </Text>
          <Text size={valueSize.current} lineHeight={lineHeight.current} wordBreak="break-word">
            {normalized.client_name}
          </Text>
        </Box>
        <Box>
          <Text size={labelSize.current} lineHeight={lineHeight.current} weight={700}>
            {t('common:reportingPeriod')}
          </Text>
          <Text size={valueSize.current} lineHeight={lineHeight.current} wordBreak="break-word">
            {normalized.reporting_period}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export type IncentiveStatementInfoBarProps = BoxProps & {
  incentiveStatement: IncentiveStatementResponse;
};
